(function ($) {

'use strict';

	/**
	 * Output message info box
	 */
	$.fn.initPageInfoMessage = function () {

		if ($(this).length !== 1) {
			return;
		}

		var $infoElement = $(this);

		// load Messie and show the info
		$.initMessi(function () {
			var dlgType = $infoElement.attr('class');
			// show the info
			if ($infoElement.hasClass('error') || $infoElement.attr('data-m-timeout') === '-1') {
				// if there is an input element with autofocus, activate after Messi msgbox was confirmed
				var extraMessiOptions = null;
				var $autoFocus = $('input[autofocus]');
				if ($autoFocus.length > 0) {
					extraMessiOptions = $.extend(extraMessiOptions,
							{callback: function () {
									setTimeout(function () {
										$autoFocus.focus();
									}, 100);
								}
							});
				}

				$.showMessiDlgToConfirm($infoElement.attr('title'), $infoElement.html(), dlgType, extraMessiOptions);
			} else {
				$.showMessiInfo($infoElement.attr('title'), $infoElement.html(), $infoElement.attr('data-m-timeout'), dlgType);
			}
			$infoElement.remove();
		});
	};	// $.fn.initPageInfoMessage

}(jQuery));